export default function Header({ theme, onToggleTheme, onNavigate }) {
  return (
    <header className="header" id="header">
      <nav className="header__controls" aria-label="Main navigation">
        <button
          onClick={() =>
            onNavigate ? onNavigate("events") : (window.location.href = "/")
          }
          className="header__nav-btn"
        >
          Events
        </button>

        <button
          className="theme-toggle"
          onClick={onToggleTheme}
          aria-label="Toggle Theme"
        >
          {theme === "dark" ? "☀️" : "🌙"}
        </button>
      </nav>

      <div className="header__content">
        <div
          className="header__brand"
          onClick={() =>
            onNavigate ? onNavigate("events") : (window.location.href = "/")
          }
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onNavigate ? onNavigate("events") : (window.location.href = "/");
            }
          }}
          style={{ cursor: "pointer" }}
        >
          <img
            src={
              theme === "dark"
                ? "/DU_logo.png"
                : "https://github.com/data-umbrella.png"
            }
            alt="Data Umbrella Logo"
            className="header__logo-img"
          />
          <h1 className="header__logo">DU Event Board</h1>
        </div>
        <p className="header__tagline">
          Discover tech events, meetups, and workshops near your region
        </p>
      </div>
    </header>
  );
}
